import { Flex, Spacer } from '@chakra-ui/react';
export const CUIFlex = Flex;
export const CUISpacer = Spacer;